import React from 'react'
import PropTypes from 'prop-types'
import Button from '@boltui/button'
import { bem } from '@argos/utils'
import classnames from 'classnames'

const cn = bem({ prefix: 'lc-', block: 'exit' })

export const Exit = ({ onSubmit, onCancel }) => {
  return (
    <div className={`${cn()} lc-controls__form`}>
      <h3 className={cn('title')}>Are you sure you want to end the chat?</h3>
      <Button full type='button' className={classnames(cn('end-btn'))} data-test={cn('end-btn')} onClick={onSubmit}>
        End Chat
      </Button>

      <Button
        full
        kind='secondary'
        type='button'
        className={classnames(cn('continue-btn'))}
        data-test={cn('continue-btn')}
        onClick={onCancel}>
        Continue Chat
      </Button>
    </div>
  )
}

Exit.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
}

export default Exit
